import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-multi-select-dropdown',
  templateUrl: './multi-select-dropdown.component.html',
  styleUrls: ['./multi-select-dropdown.component.scss'],
})
export class MultiSelectDropdownComponent implements OnInit{


  @Input() list: any[] = [];
  @Input() name = '';
  @Input() checkedCategories: any[] = [];

  @Output() shareCheckedList = new EventEmitter();
  @Output() shareIndividualCheckedList = new EventEmitter();
  showDropDown: boolean = false;

  checkedList: any[] = [];
  currentSelected: {} = {};
  
  constructor() {
    console.log(this.name, this.list, this.checkedCategories);
    
  }
  ngOnInit(): void {
    this.checkedCategories.forEach((element) => {
      console.log(element);
      this.checkedList.push (element.name);
      this.getSelectedValue(element.checked, element.name);
    });
   
    
    console.log(this.checkedList.length);
  }

  getSelectedValue(status: Boolean, value: String) {
    if (status) {
      this.checkedList.push(value);
    } else {
      var index = this.checkedList.indexOf(value);
      this.checkedList.splice(index, 1);
    }

    this.currentSelected = { checked: status, name: value };

    //share checked list
    this.shareCheckedlist();

    //share individual selected item
    this.shareIndividualStatus();
  }
  shareCheckedlist() {
    this.shareCheckedList.emit({
      name: this.name,
      selection: this.checkedList,
    });
  }
  shareIndividualStatus() {
    this.shareIndividualCheckedList.emit({
      name: this.name,
      selection: this.currentSelected,
    });
  }
}
